export default "__VITE_ASSET__BWfoWL0i__"